/* eslint-disable */
import asyncJs from './asyncJs'

class GoogleMaps {
  constructor() {
    this.promise = null
  }

  get loaded() {
    return window.google && window.google.maps
  }

  load() {
    if (!this.loaded && !this.promise) {
      this.promise = asyncJs(
        `https://maps.googleapis.com/maps/api/js?v=quarterly&key=AIzaSyA6u7aPFz-NfGtRN8z5yXewbfAqJSp7vNU&libraries=geometry,drawing`,
      )
    }
    return this.promise
  }
}

export default new GoogleMaps()
